import * as Yup from "yup";

// Delivery form validation <schema></schema>
export const subcategorySchema = Yup.object({
    name: Yup.string().required("Subcategory name is required!"),
    categoryType: Yup.string().required("Category Type is required!"),
    category: Yup.string().required("Category is required!"),
    sequence: Yup.number(),
    is_visible: Yup.boolean().required("Is category visible to user? is reuired!"),
    
  });